<template>
  <div class="  con_content">
    <div class="container">
      <div class="container_top h_48">
        协议管理

      </div>

      <div >

        <!-- table组件 -->
        <div class="my_table">
          <!-- <Header class="my_title txt_l">
              <span class='my_titleL'>
                  <Icon class="fw_900 " type="ios-list" size='30'/>
                  筛选查询
              </span>

          </Header> -->
          <div class="my_search">

            <Row class="search_row">
              <div  class="search_name">
                <Button class="mR5"    type="info"    @click='route="/layout/circle/classify/add";addFun();' > <Icon type="md-add" />添加</Button>
              </div>

            </Row>

          </div>


        </div>
        <!-- table组件 -->
        <div class="my_table  ">
          <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>
                            数据列表
                        </span>

            <div class="ct_rgt">

              <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->

            </div>
          </Header>
          <Table  border :columns="columns1" :data="data1" ref='table'>




            <!-- 按钮 -->
            <template slot-scope="{ row, index }"  slot="btn">
              <!-- <Poptip trigger="hover" :title="row.surname" content="查看"> -->

              <Poptip trigger="hover"  content="编辑">
                <Button class="padlr5" size="small"  @click='route="/layout/circle/classify/editor";editorFun(row)'  type="success"      icon="md-open"></Button>
              </Poptip>
              <Poptip trigger="hover"  content="删除">
                <Button class="padlr5"  size="small" @click='route="/layout/circle/classify/del";delFun(row)'  type="error"      icon="md-close"></Button>
              </Poptip>

            </template>

          </Table>

          <!-- 用户组编辑弹窗 -->
          <Modal
            v-model="modal1"
            title="修改协议"
            width="70%"
            class-name="vertical-center-modal"
          >
            <div slot="footer">
              <Button type='text' size='large' @click='cancel1'>取消</Button>
              <Button type='primary' size='large' @click='ok1'>修改</Button>
            </div>
            <ul class="list_ul">

              <li style="display: flex">
                <div style="width: 100px"> <span class="cRed">*</span> 标题 :</div>
                <div class="list_con">
                  <Input  v-model="model1"    type='text' class="ipt"  placeholder="请输入标题"    />
                </div>
              </li>
              <li style="display: flex">
                <div style="width: 100px"> <span class="cRed">*</span> 描述 :</div>
                <div class="list_con">
                  <Input   v-model="model2"   type='text' class="ipt"  placeholder="请输入描述"    />
                </div>
              </li>
              <li style="display: flex">
                <div style="width: 100px"> <span class="cRed">*</span> 文件名 :</div>
                <div class="list_con">
                  <Input   v-model="model4"   type='text' class="ipt"  placeholder="请输入文件名"    />
                </div>
              </li>
              <li style="display: flex">
                <div style="width: 100px"> <span class="cRed">*</span> 描述 :</div>
                <div style="width: 100%; height: 500px;">
                  <editor
                    api-key="5dnl5pqjs8244ysiyhhanjw9fpxt3d8u1oq6921li1hl29tu"
                    v-model="model3"
                    :init="editorInit"
                  />
                </div>
              </li>


            </ul>
          </Modal>


          <!-- 用户组添加弹窗 -->
          <Modal
            v-model="modal2"
            title="协议"
            width="70%"
            class-name="vertical-center-modal"
          >
            <div slot="footer">
              <Button type='text' size='large' @click='cancel_add'>取消</Button>
              <Button type='primary' size='large' @click='ok_add'>添加</Button>
            </div>
            <ul class="list_ul">


              <li style="display: flex">
                <div style="width: 100px"> <span class="cRed">*</span> 标题 :</div>
                <div class="list_con">
                  <Input  v-model="model1"    type='text' class="ipt"  placeholder="请输入标题"    />
                </div>
              </li>
              <li style="display: flex">
                <div style="width: 100px"> <span class="cRed">*</span> 描述 :</div>
                <div class="list_con">
                  <Input   v-model="model2"   type='text' class="ipt"  placeholder="请输入描述"    />
                </div>
              </li>
              <li style="display: flex">
                <div style="width: 100px"> <span class="cRed">*</span> 文件名 :</div>
                <div class="list_con">
                  <Input   v-model="model4"   type='text' class="ipt"  placeholder="请输入文件名"    />
                </div>
              </li>
              <li style="display: flex">
                <div style="width: 100px"> <span class="cRed">*</span> 描述 :</div>
                <div style="width: 100%; height: 500px;">
                  <editor
                    api-key="5dnl5pqjs8244ysiyhhanjw9fpxt3d8u1oq6921li1hl29tu"
                    v-model="model3"
                    :init="editorInit"
                  />
                </div>
              </li>


            </ul>
          </Modal>
          <!-- 确认删除框 -->
          <Modal
            v-model="delM"
            title="提示"
            @on-ok="delOk"
            @on-cancel="cancel"
            class-name="vertical-center-modal"
          >
            <p>确定删除吗?</p>

          </Modal>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import axios from 'axios'
import Editor from '@tinymce/tinymce-vue'
import { mapState,mapMutations,mapGetters } from 'vuex';
import { format } from 'path';
import cropper from "@/views/child_vue/vue_cropper.vue";

export default {
  components: {Editor},
  name:'classify',
  data () {
    return {
      route: null,
      token:'',
      delId: '',

      columns1:[],

      data1:[],


      checkGuid2:'',



      modal1: false, // 编辑举报
      modal2: false,   //添加举报
      delM: false,

      model1: null,
      model2: null,
      model3: null,
      model4: null,
      editorInit: {},

    }
  },

  watch:{


  },

  computed: {



  },
  created(){

    //设置上传图片的地址
    this.action ="https://api.jiapuji.vip/gateway/attached/service/attached/upload?type=14&guid="+this.$store.state.guid
    this.videoAction = "https://api.jiapuji.vip/gateway/attached/service/attached/upload?type=15&guid="+this.$store.state.guid
    this.token = this.$store.state.token
    
    // TinyMCE 配置
    this.editorInit = {
      language_url: '/tinymce/langs/zh_CN.js',
      language: 'zh_CN',
      skin_url: '/tinymce/skins/ui/oxide',
      content_css: '/tinymce/skins/content/default/content.css',
      height: 500,
      menubar: true,
      promotion: false, // 禁用升级提示
      branding: false, // 移除"Powered by TinyMCE"
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount'
      ],
      toolbar: 'undo redo | formatselect | bold italic backcolor | \
               alignleft aligncenter alignright alignjustify | \
               bullist numlist outdent indent | removeformat | image | help',
      images_upload_handler: (blobInfo, success, failure) => {
        const formData = new FormData();
        formData.append('file', blobInfo.blob(), blobInfo.filename());
        
        axios({
          url: "https://api.jiapuji.vip/gateway/attached/service/attached/upload?type=14&guid="+this.$store.state.guid,
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.token,
            'Content-Type': 'multipart/form-data'
          },
          data: formData
        }).then(res => {
          if(res.data.code == 1){
            this.$Message.success('上传成功！');
            success(res.data.data.path);
          } else {
            this.$Message.error('上传失败！');
            failure('上传失败');
          }
        }).catch(err => {
          console.log(err);
          this.$Message.error('上传失败！');
          failure('上传失败');
        });
      }
    }

  },
  methods: {
    load(){
      let that = this;

      that.$myAjax.get(
        'admin/protocol/list?route=/layout/jurisdiction/admin/editor'
      ).then(res => {
        that.columns1 = [
          {title:'名字',key:'title',align:'center'},
          {title:'描述',key:'description',align:'center'},
          {title:'路径',key:'url',align:'center'},
          {title:'添加时间',key:'createTime',align:'center'},
          {title:'修改时间',key:'updateTime',align:'center'},
          {title:'操作',slot:'btn',align:'center',fixed: 'right',width: 150}
        ];
        that.data1 = res.data.data;

      });





    },



    // 用户组名编辑
    editorFun(res){
      let that = this;


      that.$canBtn( that.route).then( function(res_c){
        that.modal1 = true;

        that.guid = res.id;
        that.model1 = res.title;
        that.model2 = res.description;
        that.model3 = res.content;
        that.model4 = res.fileName;

      })
    },


    //    编辑弹窗
    ok1() {
      var that = this;
      that.$ajax({

        method:'post',
        url: 'admin/protocol?route=/layout/circle/classify/editor',
        data: {
          id: that.guid,
          title: that.model1,
          description: that.model2,
          content: that.model3,
          fileName: that.model4
        },

      }).then(res => {
        that.$alert.info(res);
        if(res.data.code == 1){
          that.load();
          that.cancel1();
        }
      }).catch(err=>{
        console.log(err)
      })



    },
    cancel1() {
      this.modal1 = false;


    },

    // 删除用户组
    delFun(res){
      let that = this;

      that.guid = res.guid;
      that.delId = res.id
      that.$canBtn( that.route).then( function(res_c){
        that.guid = res.guid;
        that.delM = true;
      })
    },
    delOk(){
      let that = this;
      that.$ajax({

        method:'delete',
        url: 'admin/protocol/'+ that.delId +'?route='+that.route,
        data:{
        },

      }).then(res => {
        that.$alert.info(res);

        that.load();
      })

    },
    
    // 顶部添加
    addFun(){
      let that = this;
      that.$canBtn( that.route).then( function(res_c){
        that.modal2 = true;

        that.model1 = null;
        that.model2 = null;
        that.model3 = null;
        that.model4 = null;
      })
    },
    ok_add(){
      let that = this;

      that.$myAjax.post(
        'admin/protocol?route=/layout/circle/classify/editor',
        {
          title: that.model1,
          description: that.model2,
          content: that.model3,
          fileName: that.model4
        }
      ).then(res => {
        // that.$alert.info(res);

        if(res.data.code != 0){
          that.load();
          that.cancel_add();
        }

      })



    },
    cancel_add(){

      this.modal2 = false;
    },

    cancel(){},



  },
  mounted: function(){
    var that = this;
    that.vCropper = that.$store.state.vCropper;

    that.token = that.$store.state.token;

    that.load();


  }
}
</script>
<style scoped>
/* public 内容用  /就行 */
@import "/css/modal.css";
</style>




